import { Lightning } from '@lightningjs/sdk';
import { getInitialStyle, defaultContext } from './sliderThumb.style';

export class SliderThumb extends Lightning.Component {
  static _template() {
    return {
      rect: true,
      ...getInitialStyle(),
    };
  }

  _construct() {
    this._style = defaultContext;
  }

  get colorMode() {
    return this._style.colorMode;
  }

  set colorMode(value) {
    this._style = { ...this._style, colorMode: value };
    this.patch(getInitialStyle(this._style));
  }
}
